/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Answer to `pick-from-list-question`
 * @export
 * @interface PaxCheckFromList
 */
export interface PaxCheckFromList {
    /**
     * Question id
     * @type {string}
     * @memberof PaxCheckFromList
     */
    questionId: string;
    /**
     * Answer value - chosen option id
     * @type {string}
     * @memberof PaxCheckFromList
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckFromList
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckFromList interface.
 */
export function instanceOfPaxCheckFromList(value: object): value is PaxCheckFromList {
    if (!('questionId' in value) || value['questionId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckFromListFromJSON(json: any): PaxCheckFromList {
    return PaxCheckFromListFromJSONTyped(json, false);
}

export function PaxCheckFromListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckFromList {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['question_id'],
        'value': json['value'],
        'type': json['type'],
    };
}

export function PaxCheckFromListToJSON(json: any): PaxCheckFromList {
    return PaxCheckFromListToJSONTyped(json, false);
}

export function PaxCheckFromListToJSONTyped(value?: PaxCheckFromList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question_id': value['questionId'],
        'value': value['value'],
        'type': value['type'],
    };
}

